import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import GlobalModel from 'echarts/lib/model/Global';
import GraphSeriesModel, { GraphNodeItemOption } from 'echarts/lib/chart/graph/GraphSeries';
import { AxisBaseModel } from 'echarts/lib/coord/AxisBaseModel';

interface LayoutNode {
  x: number;
  y: number;
  idx: number;
  radius: number;
}
export function staticLayout(ecModel: GlobalModel, api: ExtensionAPI) {
  ecModel.eachSeriesByType('graph', function (graphSeries: GraphSeriesModel) {
    const coordSys = graphSeries.coordinateSystem;
    const layout = graphSeries.get('layout') as unknown;
    if (!coordSys || coordSys.type !== 'view') {
      return;
    }
    if (layout === 'static') {
      const graph = graphSeries.getGraph();
      const nodeData = graph.data;
      const staticModel = graphSeries.getModel('static') || {};
      const axisIndex = staticModel.get('axisIndex') || 0;
      const axisIns = ecModel.getComponent('yAxis', axisIndex) as AxisBaseModel;
      if (!axisIns) {
        throw new Error('beeswarm layout need axis');
      }
      const axis2D = axisIns.axis;
      const coord = graphSeries.coordinateSystem;
      const rect = coord.getBoundingRect();
      // const rect = coord.getBoundingRect!().clone();
      // const transform = coord.getComputedTransform();
      // rect.applyTransform(transform);

      // 获取初始位置信息
      const nodes = nodeData.mapArray('value', function (value: number, idx) {
        return {
          idx,
          x: rect.x + rect.width / 2,
          y: axis2D.toGlobalCoord(axis2D.dataToCoord(value)),
          radius: (nodeData.getItemModel<GraphNodeItemOption>(idx).get('symbolSize') as number) / 2
        };
      }) as LayoutNode[];

      // 半径从大到小排列
      nodes.sort((a, b) => b.radius - a.radius);

      // 偏移x以保证不重叠
      function isOverlap(node: LayoutNode, prevNodes: LayoutNode[]) {
        return prevNodes.some(prevNode => {
          const distance = Math.sqrt((node.x - prevNode.x) ** 2 + (node.y - prevNode.y) ** 2);
          return distance < node.radius + prevNode.radius;
        });
      }

      nodes.forEach((node, i) => {
        const prevNodes = nodes.slice(0, i);
        let sign = 1;
        let step = 1;
        const startX = node.x;

        while (isOverlap(node, prevNodes)) {
          node.x = startX + sign * step;
          sign = -sign;
          if (sign > 0) {
            step += 1;
          }
        }
      });

      // 应用布局
      nodes.forEach(node => {
        nodeData.setItemLayout(node.idx, [node.x, node.y]);
      });
    }
  });
}
